import React from 'react';
import { Modal, Input } from 'antd';

import background_circle_blue_modal from 'images/background_circle_blue_modal.svg';
import icon_plus_white from 'images/icon_plus_white.svg';

const AddSection = (props) => {
    return (
        <>
            <Modal
                className="basic-modal"
                title=""
                visible={props.addSectionModalIsVisible}
                onOk={props.handleOkAddSection}
                onCancel={props.handleCanceladdSection}
                footer={null}
                closable={false}
                bodyStyle={{ height: 450 }}
                width={300}
            >
                <div className="icon-container">
                    <img
                        className="img-icon-container"
                        src={background_circle_blue_modal}
                    />
                    <img
                        style={{ height: '30px', right: 20, top: 25 }}
                        className="icon-in-green-circle"
                        src={icon_plus_white}
                    />
                </div>
                <div>
                    <div style={{ padding: '8px 0 0 0', marginLeft: 6 }}>
                        <p className="header-title">Add Section</p>
                        <p
                            className="p-desctiption"
                            style={{ marginBottom: '90px' }}
                        >
                            Type the name of the section and <br />
                            then confirm by clicking "Create"
                        </p>
                    </div>
                    <Input
                        placeholder="Section name"
                        onChange={props.handleChangeInputAddSection}
                        style={{ marginBottom: 5 }}
                    ></Input>

                    <div>
                        <button
                            className="ant-btn ant-btn-primary ant-btn-block blue-button"
                            onClick={props.handleOkAddSection}
                            style={{ width: '100%', marginTop: '30px' }}
                        >
                            CREATE
                        </button>
                    </div>
                    <button
                        onClick={props.handleCanceladdSection}
                        style={{
                            width: '100%',
                            marginTop: 10,
                            color: '#407CB1',
                            height: '26px',
                            backgroundColor: '#fff',
                            border: '1px solid #578CBA'
                        }}
                    >
                        CANCEL
                    </button>
                </div>
            </Modal>
        </>
    );
};

export default AddSection;
